import { lazy } from 'react';
import { paths } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import { TypedRouteObject } from '../types';

// 동적 임포트
const Dashboard = lazy(() => import('@/pages/dashboard/Dashboard'));

/**
 * 대시보드 라우트
 */
export const dashboardRoutes: TypedRouteObject = {
	children: [
		{
			path: paths.home.path,
			element: withSuspense(Dashboard),
			handle: {
				permission: 'DASHBOARD' as const
			}
		},
		{
			path: paths.dashboard.path,
			element: withSuspense(Dashboard),
			handle: {
				permission: 'DASHBOARD' as const
			}
		}
	]
};
